import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pagetitle-modal',
  template: `
<div class="row pb-3">
  <div class="col-12">

    <h2 *ngIf="PageTitle && PageTitle!=''" [innerHtml]="PageTitle"></h2>
    <p class="lead"><small [innerHtml]="PageLeadPara"></small></p>
    <button *ngIf="ModalButton" class="btn btn-secondary" (click)="open(content)">{{ ModalButton }}</button>

    <ng-template #content let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title" [innerHtml]="ModalTitle"></h4>
        <button type="button" class="close" [attr.aria-label]="ModalCloseButton" (click)="d()">
          <fa name="times"></fa>
        </button>
      </div>

      <div class="modal-body"><p [innerHtml]="ModalBody"></p></div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="c()">{{ ModalCloseButton }}</button>
        <a role="button" class="btn btn-secondary" href="{{ ModalLink }}" target="_blank">{{ ModalContinueButton }}</a>
      </div>
    </ng-template>

    <hr aria-hidden="true" />
  </div>
</div>
`
})
export class PageTitleModalComponent {
  @Input() PageTitle: string;
  @Input() PageLeadPara: string;
  @Input() ModalButton: string;
  @Input() ModalTitle: string;
  @Input() ModalBody: string;
  @Input() ModalCloseButton: string;
  @Input() ModalContinueButton: string;
  @Input() ModalLink: string;

  constructor(private modalService: NgbModal) { }

  open(content: any): void {
    this.modalService.open(content, { windowClass: 'modal-managemyhome' });
  }
}



// WEBPACK FOOTER //
// ./src/app/global/pagetitlemodal.component.ts